var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _circle4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle5, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawPersonalSiteReC4Bp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 883 518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M867 438H226a17 17 0 0 1-16-17V26a12 12 0 0 1 12-12h649a12 12 0 0 1 12 12v395a17 17 0 0 1-16 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M844 414H246c-8 0-16-6-16-15V55c0-6 6-11 12-11h605c7 0 12 5 12 11v344c0 9-7 15-15 15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M883 25H209v-8a17 17 0 0 1 17-17h641a17 17 0 0 1 16 17Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.4,
    cy: 12.5,
    r: 4.3,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.7,
    cy: 12.5,
    r: 4.3,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.9,
    cy: 12.5,
    r: 4.3,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M342 350H193a18 18 0 0 1-18-17V157a13 13 0 0 1 13-14h158a13 13 0 0 1 13 14v176a18 18 0 0 1-17 17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M342 350H193a18 18 0 0 1-18-17V157a13 13 0 0 1 13-14h158a13 13 0 0 1 13 14v176a18 18 0 0 1-17 17ZM188 145a11 11 0 0 0-11 12v176a16 16 0 0 0 16 15h149a16 16 0 0 0 15-15V157a11 11 0 0 0-11-12Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.2,
    cy: 225.3,
    r: 30.7,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M316 299h-98a34 34 0 0 1 34-34h30a34 34 0 0 1 34 34Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M181 283a10 10 0 0 1-14-6l-36-1 11-15 33 3a10 10 0 0 1 6 19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m82 269-19-38a31 31 0 0 1 2-33l2-2a30 30 0 0 1 25-11 31 31 0 0 1 25 15l9 14c1 1 14 13 9 28l-1 15a5 5 0 0 1-3 4l-44 10a4 4 0 0 1-5-2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M68 341a10 10 0 0 1 2-15l-9-35 17 6 6 32a10 10 0 0 1-16 12Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M64 325a4 4 0 0 1-2-4l-6-59a50 50 0 0 1-1-14l8-44a10 10 0 0 1 10-9 10 10 0 0 1 10 11l-6 51 6 59a4 4 0 0 1-2 5l-13 4a4 4 0 0 1-4 0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m162 504 12-2-3-47-18 3 9 46z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m158 501 24-4a15 15 0 0 1 18 12l-39 8Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M55 505h12l6-48H55v48z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M52 501h24a15 15 0 0 1 16 15v1H52Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 150.3,
    r: 24.6,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M53 486a5 5 0 0 1-1-4l17-151c0-2-3-28 16-61l49-13 6 23 36 200a4 4 0 0 1-4 5l-12 2a5 5 0 0 1-5-4l-43-135a2 2 0 0 0-3 0L73 484a5 5 0 0 1-4 3H56a5 5 0 0 1-3-1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m157 281-53-9a17 17 0 0 1-14-14l-11-53a14 14 0 0 1 13-17 14 14 0 0 1 15 13l6 47 47 12a4 4 0 0 1 3 4v12a4 4 0 0 1-6 5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M112 145c4-1 8-4 9-8 1-3-1-7-3-9a20 20 0 0 0-24-6c1-2-1-4-2-5a14 14 0 0 0-6-1c-7 1-14 1-19 4-4 3-7 8-8 13l-2 15 3 28 18 5 21 5 5-1-1-3c-3-5-7-9-9-14s-4-11-2-16 16-7 20-7Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M498 317h319a16 16 0 0 0 16-16V157a16 16 0 0 0-16-16H498a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M782 237H527a8 8 0 1 1 0-16h255a8 8 0 0 1 0 16Zm0 34H527a8 8 0 1 1 0-16h255a8 8 0 0 1 0 16Zm-45-68H527a8 8 0 1 1 0-16h210a8 8 0 0 1 0 16Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M240 518H1a1 1 0 0 1 0-2h239a1 1 0 1 1 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPersonalSiteReC4Bp);
export default __webpack_public_path__ + "static/media/undraw_personal_site_re_c4bp.d43931e827ae0c08c31debca6e61f72f.svg";
export { ForwardRef as ReactComponent };